import { render, staticRenderFns } from "./payfor-check.vue?vue&type=template&id=7f50575a"
import script from "./payfor-check.vue?vue&type=script&lang=js"
export * from "./payfor-check.vue?vue&type=script&lang=js"
import style0 from "./payfor-check.vue?vue&type=style&index=0&id=7f50575a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports